import {
  SpaceBetween,
  Button,
  FormField,
  Container,
} from "@cloudscape-design/components-themed";
import { useNavigate } from "react-router-dom";
import { LABELS } from "./constants";

/* 
ホールディングス案件のヘッダ
 */
const Header = () => {
  const navigate = useNavigate();
  return (
    <SpaceBetween size="m">
      <Container>
        <FormField label={LABELS.HOLDINGS_LEAD_NEW_ENTRY}>
          <Button
            onClick={() => {
              navigate("/holdings-register");
            }}
          >
            {LABELS.HOLDINGS_NEW_ENTRY}
          </Button>
        </FormField>
      </Container>
    </SpaceBetween>
  );
};

export default Header;
